module.exports = __webpack_public_path__ + "images/icons_v2/volume-off-outlined-08e5440e.svg";